/**
 * Petbabe Minimal High-Performance Theme JS
 * Zero external heavy library dependencies
 */
document.addEventListener('DOMContentLoaded', () => {
  // Mobile Cart Drawer trigger
  const trigger = document.getElementById('cart-drawer-trigger');
  const drawer = document.getElementById('cart-drawer');
  const closeBtn = document.querySelector('.close-cart-btn');
  const overlay = document.querySelector('.cart-overlay');

  function openCart() {
    document.body.classList.add('cart-drawer-open');
  }

  function closeCart() {
    document.body.classList.remove('cart-drawer-open');
  }

  if (trigger) trigger.addEventListener('click', openCart);
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  // Pattern Switcher
  const swatches = document.querySelectorAll('.pattern-swatch-btn');
  const patternName = document.getElementById('selected-pattern-name');

  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      swatches.forEach(s => s.classList.remove('border-2', 'border-[#2F4A3C]', 'active'));
      swatch.classList.add('border-2', 'border-[#2F4A3C]', 'active');
      if (patternName) patternName.textContent = swatch.dataset.pattern;
    });
  });
});